<div [class.picker-wrapper]="showLabel()">
    <form [formGroup]="periodPickerForm">
        @if (showLabel()) {
            <label for="periodControl" class="picker-label">{{ 'dashboard.visuals.components.periodPicker.label' | translate }}:</label>
        }
        <select formControlName="periodControl">
            @for (option of filterOptions(); track option.value) {
                <option [value]="option.value">{{ option.label | translate }}</option>
            }
        </select>
    </form>
</div>
